/* eslint-disable react/jsx-filename-extension */

import React from 'react';
import ReactDOM from 'react-dom';

import GlossaryWord from './GlossaryWord';

const glossaryWordContainers = document.querySelectorAll('[data-glossary-word]');

[...glossaryWordContainers].forEach((glossaryWord) => {
    ReactDOM.render(
        <GlossaryWord
            title={glossaryWord.dataset.title}
            description={decodeURIComponent(glossaryWord.dataset.description)}
            original={glossaryWord.innerHTML}
        />,
        glossaryWord,
    );
});
